export const FACTORS = {
  AGE: "Credit age",
  UTILIZATION: "Credit utilization",
  CHECKS: "Credit checks",
  OPEN_ACCOUNTS: "Total open accounts"
};

export const FACTOR_DESCRIPTION = {
  AGE: "Length of credit history",
  UTILIZATION: "Percent of credit utilized across all of your open accounts",
  CHECKS: "Number of inquiries in the last 2 years",
  OPEN_ACCOUNTS: "Number of all open accounts listed on your credit report"
};

export const RATINGS = {
  EXCELLENT: "Excellent",
  GOOD: "Good",
  FAIR: "Fair",
  NEEDS_WORK: "Needs Work"
};

export const getRating = (type, value) => {
  switch (type) {
    case FACTORS.AGE:
      if (value.years() <= 4) {
        return RATINGS.NEEDS_WORK;
      }
      if (value.years() <= 6) {
        return RATINGS.FAIR;
      }
      if (value.years() <= 8) {
        return RATINGS.GOOD;
      }
      return RATINGS.EXCELLENT;
    case FACTORS.UTILIZATION:
      if (value <= 0.09) {
        return RATINGS.EXCELLENT;
      }
      if (value <= 0.29) {
        return RATINGS.GOOD;
      }
      if (value <= 0.49) {
        return RATINGS.FAIR;
      }
      return RATINGS.NEEDS_WORK;
    case FACTORS.CHECKS:
      if (value === 0) {
        return RATINGS.EXCELLENT;
      }
      if (value <= 2) {
        return RATINGS.GOOD;
      }
      if (value <= 4) {
        return RATINGS.FAIR;
      }
      return RATINGS.NEEDS_WORK;
    case FACTORS.OPEN_ACCOUNTS:
      if (value <= 10) {
        return RATINGS.NEEDS_WORK;
      }
      if (value <= 20) {
        return RATINGS.FAIR;
      }
      return RATINGS.EXCELLENT;
    default:
      return "N/A";
  }
};
